import React from 'react';
import Slider from 'react-slick';
import './ourclient.css';

import one from "../../assets/ourclients/accenture.webp";
import two from "../../assets/ourclients/amazon.webp";
import three from "../../assets/ourclients/avasoft.webp";
import four from "../../assets/ourclients/capegimin.webp";
import five from "../../assets/ourclients/client-1.png";
import six from "../../assets/ourclients/client-2.png";
import seven from "../../assets/ourclients/client-3.png";
import eight from "../../assets/ourclients/client-4.png";
import nine from "../../assets/ourclients/client-5.png";
import ten from "../../assets/ourclients/client-6.png";
import elven from "../../assets/ourclients/client-7.png";
import twele from "../../assets/ourclients/client-8.png";
import thirteen from "../../assets/ourclients/cts.webp";
import fourteen from "../../assets/ourclients/hcl.webp";
import fifteen from "../../assets/ourclients/syntel.webp";

function OurClients() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // tablets
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // small tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // mobile phones
        settings: {
          slidesToShow: 1,  // ✅ Show only one logo on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="our-clients-section">
      <div className="our-clients">
        <section className="section-margin">
         <div className="headlines-for-all">
  <h4>
    <span>Our </span> Clients
  </h4>
  <p>
    We’re proud to have trained and collaborated with leading IT companies and 
    growing startups. Our students are placed in top organizations that trust 
    our commitment to quality learning and job-ready skills.
  </p>
</div>

        </section>

        <Slider {...settings}>
          <div className="client-item"><img src={one} alt="Client 1" /></div>
          <div className="client-item"><img src={two} alt="Client 2" /></div>
          <div className="client-item"><img src={three} alt="Client 3" /></div>
          <div className="client-item"><img src={four} alt="Client 4" /></div>
          <div className="client-item"><img src={five} alt="Client 5" /></div>
          <div className="client-item"><img src={six} alt="Client 6" /></div>
          <div className="client-item"><img src={seven} alt="Client 7" /></div>
          <div className="client-item"><img src={eight} alt="Client 8" /></div>
          <div className="client-item"><img src={nine} alt="Client 9" /></div>
          <div className="client-item"><img src={ten} alt="Client 10" /></div>
          <div className="client-item"><img src={elven} alt="Client 11" /></div>
          <div className="client-item"><img src={twele} alt="Client 12" /></div>
          <div className="client-item"><img src={thirteen} alt="Client 13" /></div>
          <div className="client-item"><img src={fourteen} alt="Client 14" /></div>
          <div className="client-item"><img src={fifteen} alt="Client 15" /></div>

        </Slider>
      </div>
    </section>
  );
}

export default OurClients;
